import React from 'react';
export const ClearIcon = () => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20", fill: "currentColor" },
        React.createElement("path", { fillRule: "evenodd", d: "M16 4.707 15.293 4 10 9.293 4.707 4 4 4.707 9.293 10 4 15.293l.707.707L10 10.707 15.293 16l.707-.707L10.707 10 16 4.707Z" })));
};
//# sourceMappingURL=ClearIcon.js.map